module.exports = __webpack_public_path__ + "img/FF_Info_Game_12.4c284dba.png";